export default __webpack_public_path__ + "static/media/bg.fd1fe05c.png";